import register from 'ShopUiBundle/modules/app/registry';

import 'ShopUiBundle/components/molecules/basic-slider';
import './style.scss';

// tslint:disable-next-line
register('bike-detail-slider', () => import(/* webpackMode: "lazy" */'./bike-detail-slider'));
